import type { ReactElement } from 'react';
import { WORKER_OFFERING_WAIT_NOTE, type WorkerOfferingChoice } from '../lib/worker-offering-choice';

/**
 * #250 the one Worker AI selector: Auto or an exact pin, sent through set_worker_offering.
 * Used by Settings > AI Workforce and by the Worker card; locked while a run is in progress.
 */
export function WorkerOfferingSelect({ choice, busy, onChange, className = 'row' }: {
  readonly choice: WorkerOfferingChoice;
  readonly busy: boolean;
  readonly onChange: (workerId: string, nodeId: string, offeringKey: string | null) => void;
  readonly className?: string;
}): ReactElement {
  return (
    <label className={className}>
      <span>AI</span>
      <select aria-label={`AI for Worker ${choice.workerNumber}`} disabled={busy || choice.working}
        value={choice.preferenceKey ?? ''}
        onChange={(event) => onChange(choice.workerId, choice.nodeId, event.target.value || null)}>
        <option value="">Auto — Brunel chooses</option>
        {choice.options.map((option) => (
          <option key={option.key} value={option.key}>{option.label}</option>
        ))}
      </select>
      {choice.working && <small className="muted">{WORKER_OFFERING_WAIT_NOTE}</small>}
    </label>
  );
}
